module.exports = __webpack_public_path__ + "img/mon_24.04120fb0.png";